import { AppServices, Routing } from '@singularsystems/neo-core';

import { AppService, Types } from './AwardsTypes';
import { IAppMenuItem } from 'st-app/Services/RouteService';
import ApprovalsQueryApiClient from 'st-common/Awards/ApiClients/Approvals/ApprovalsQueryApiClient';
import ApprovalsCommandApiClient from './ApiClients/Approvals/ApprovalsCommandApiClient';
import ParticipantOffersQueryApiClient from './ApiClients/ParticipantOffers/ParticipantOffersQueryApiClient';
import ParticipantAcceptanceCommandApiClient from './ApiClients/ParticipantOffers/ParticipantAcceptanceCommandApiClient';

import ApprovalsView from './Views/Approvals/ApprovalsView';
import ReleaseView from './Views/AwardRelease/ReleaseView';
import MyAwardsView from './Views/MyAwards/MyAwardsView';
import AcceptAwardsView from './Views/MyAwards/AcceptAwardsView';
import { CatalogueQueryApiClient } from 'st-common/Awards/ApiClients/CatalogueQueryApiClient';
import AwardUtils from 'st-common/Awards/Services/AwardUtils';
import AwardsDataCache from './Services/AwardsDataCache';
import OfferTotalsService from 'st-common/Awards/Services/OfferTotalsService';
import IncentiveSchemesQueryApiClient from 'st-common/Awards/ApiClients/IncentiveSchemesQueryApiClient';
import AwardDocumentsQueryApiClient from 'st-common/Awards/ApiClients/AwardDocuments/AwardDocumentsQueryApiClient';
import AwardDocumentsCommandApiClient from 'st-common/Awards/ApiClients/AwardDocuments/AwardDocumentsCommandApiClient';
import IncentiveGroupsQueryApiClient from 'st-common/Awards/ApiClients/IncentiveGroupsQueryApiClient';
import AwardModuleConfigApiClient from 'st-common/Awards/ApiClients/Config/AwardModuleConfigApiClient';
import AnswerQuestionnaireQueryApiClient from 'st-common/Awards/ApiClients/Questionnaires/AnswerQuestionnaireQueryApiClient';
import AnswerQuestionnaireCommandApiClient from 'st-common/Awards/ApiClients/Questionnaires/AnswerQuestionnaireCommandApiClient';
import MyAwardsApiClient from './ApiClients/ParticipantOffers/MyAwardsApiClient';
import SurveysApiClient from 'st-common/Awards/ApiClients/SurveysApiClient';
import SurveyCompletionView from './Views/Surveys/SurveyCompletionView';

// Modules
const awardsAppModule = new AppServices.Module("Clients", container => {
    // Api Clients
    container.bind(Types.Awards.ApiClients.ApprovalsQueryApiClient).to(ApprovalsQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.ApprovalsCommandApiClient).to(ApprovalsCommandApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.CatalogueQueryApiClient).to(CatalogueQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.ParticipantOffersQueryApiClient).to(ParticipantOffersQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.MyAwardsApiClient).to(MyAwardsApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.ParticipantAcceptanceCommandApiClient).to(ParticipantAcceptanceCommandApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.AnswerQuestionnaireQueryApiClient).to(AnswerQuestionnaireQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.AnswerQuestionnaireCommandApiClient).to(AnswerQuestionnaireCommandApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.IncentiveSchemesQueryApiClient).to(IncentiveSchemesQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.IncentiveGroupsQueryApiClient).to(IncentiveGroupsQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.AwardDocumentsQueryApiClient).to(AwardDocumentsQueryApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.AwardDocumentCommandApiClient).to(AwardDocumentsCommandApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.AwardModuleConfigApiClient).to(AwardModuleConfigApiClient).inSingletonScope();
    container.bind(Types.Awards.ApiClients.SurveysApiClient).to(SurveysApiClient).inSingletonScope();

    // Services
    container.bind(Types.Awards.Services.AwardUtils).to(AwardUtils).inSingletonScope();
    container.bind(Types.Awards.Services.OfferTotalsService).to(OfferTotalsService).inSingletonScope();
    container.bind(Types.Awards.Services.AwardsDataCache).to(AwardsDataCache).inSingletonScope();    
});

// Test 
const awardsTestModule = new AppServices.Module("Clients", container => {
    // bind test types
});

// Routes
const ApprovalsRoute: Routing.IMenuRoute =
    { name: "Approvals", path: "/approvals", component: ApprovalsView }

const ReleaseRoute: IAppMenuItem = {
    name: "Release", path: "/release", component: ReleaseView,
    showMenuItem: () => {
        const cache = AppService.get(Types.Awards.Services.AwardsDataCache);
        return (cache.awardModuleConfig.currentData?.awardRelease?.showAwardReleaseMenuItem ?? false) || cache.hasPendingApprovals;
    }
}

const AcceptAwardsRoute: Routing.IMenuRoute =
    { name: "My Pending Awards", path: "/my-awards/accept", component: AcceptAwardsView }

const MyAwardsRoute: Routing.IMenuRoute =
    { name: "My Awards", path: "/my-awards", component: MyAwardsView, exact: true, routeChildren: [AcceptAwardsRoute] }

const SurveyRoute: Routing.IMenuRoute =
    { name: "Surveys", path: "/complete-survey", component: SurveyCompletionView, exact: true }

const AwardsPureRoutes = [ApprovalsRoute, AcceptAwardsRoute, SurveyRoute];

export {
    ReleaseView,
    MyAwardsView,
    AcceptAwardsView,
    SurveyCompletionView,
    awardsAppModule,
    awardsTestModule,
    AwardsPureRoutes,
    ApprovalsRoute,
    ReleaseRoute,
    MyAwardsRoute
}